module.exports = __webpack_public_path__ + "img/melatie-lines.07445ca3.png";